// extracted by mini-css-extract-plugin
export default {"row":"n0o9o","label":"YFXHy","field":"HkSBw","menuItemParents":"JnQvv"};